import React from 'react';
import ImageBlockField, { fieldCls } from './ImageBlockField';

export const BLOCK_TYPES = [
  { type: 'p', label: 'Paragraph' },
  { type: 'h2', label: 'Heading H2' },
  { type: 'h3', label: 'Heading H3' },
  { type: 'ul', label: 'Bullet list' },
  { type: 'img', label: 'Photo' },
];

export const blockLabel = (type) => BLOCK_TYPES.find((b) => b.type === type)?.label || type;

export function BlockFields({ block, onChange, testid }) {
  if (block.type === 'img') return <ImageBlockField block={block} onChange={onChange} testid={testid} />;
  if (block.type === 'ul') {
    return (
      <textarea
        value={(block.items || []).join('\n')}
        onChange={(e) => onChange({ ...block, items: e.target.value.split('\n') })}
        rows={Math.max(3, (block.items || []).length + 1)}
        placeholder="One bullet per line"
        className={`${fieldCls} resize-y`}
        data-testid={`${testid}-items`}
      />
    );
  }
  if (block.type === 'h2' || block.type === 'h3') {
    return (
      <input
        value={block.text || ''}
        onChange={(e) => onChange({ ...block, text: e.target.value })}
        placeholder={block.type === 'h2' ? 'Section heading' : 'Sub-heading'}
        className={`${fieldCls} font-display uppercase tracking-tight ${block.type === 'h2' ? 'text-xl' : 'text-lg'}`}
        data-testid={`${testid}-text`}
      />
    );
  }
  return (
    <textarea
      value={block.text || ''}
      onChange={(e) => onChange({ ...block, text: e.target.value })}
      rows={Math.min(12, Math.max(3, Math.ceil((block.text || '').length / 90)))}
      placeholder="Write a paragraph…"
      className={`${fieldCls} resize-y leading-relaxed`}
      data-testid={`${testid}-text`}
    />
  );
}

let seq = 0;
export const withKeys = (blocks) => (blocks || []).map((b) => ({ ...b, _key: `b${(seq += 1)}` }));
export const newBlock = (type) =>
  withKeys([type === 'ul' ? { type, items: [] } : type === 'img' ? { type, src: '', alt: '', caption: '' } : { type, text: '' }])[0];

// Strip editor-only keys and drop empty blocks before saving.
export function cleanBlocks(blocks) {
  return blocks
    .map(({ _key, ...b }) => {
      if (b.type === 'ul') return { type: 'ul', items: b.items.map((s) => s.trim()).filter(Boolean) };
      if (b.type === 'img') {
        const out = { type: 'img', src: b.src, alt: (b.alt || '').trim(), caption: (b.caption || '').trim() };
        if (b.width) Object.assign(out, { width: b.width, height: b.height });
        return out;
      }
      return { type: b.type, text: b.text };
    })
    .filter((b) => (b.type === 'ul' ? b.items.length : b.type === 'img' ? b.src : (b.text || '').trim()));
}
